import LatestBillList from '@/views/App/Billing/Existing/LatestBills/List.vue';
import ArchivedBillList from '@/views/App/Billing/Existing/Archived/List.vue';
import CoachingSelection from "@/views/App/Billing/Creating/CoachingSelection.vue";
import PrivateCoachingPreviewList from "@/views/App/Billing/Creating/PrivateCoaching/PreviewList.vue";
import GroupCoachingPreviewList from "@/views/App/Billing/Creating/GroupCoaching/PreviewList.vue";
import CaseManagementCoachingPreviewList from "@/views/App/Billing/Creating/CaseManagementCoaching/PreviewList.vue";
import PrivateLearningCoachingPreviewList from "@/views/App/Billing/Creating/PrivateLearningCoaching/PreviewList.vue";
import AssistedLivingCoachingPreviewList from "@/views/App/Billing/Creating/AssistedLivingCoaching/PreviewList.vue";
import SocioTherapyCoachingPreviewList from "@/views/App/Billing/Creating/SocioTherapyCoaching/PreviewList.vue";
import SpecialCaseForm from "@/views/App/Billing/Creating/SpecialCase/Form.vue";
import SocioTherapyCoachingBillCorrectionForm from "@/views/App/Billing/Existing/Correction/SocioTherapyCoachingBillCorrectionForm.vue";


const routesBilling = [
    // List
    {
        path: 'latest-bills',
        name: 'billingLatestBills',
        component: LatestBillList
    },
    {
        path: 'archived-bills',
        name: 'billingArchivedBills',
        component: ArchivedBillList
    },

    // Creating
    {
        path: 'coaching-selection',
        name: 'billingCoachingSelection',
        component: CoachingSelection
    },
    {
        path: 'private-coaching-preview-list',
        name: 'billingPrivateCoachingPreviewList',
        component: PrivateCoachingPreviewList
    },
    {
        path: 'group-coaching-preview-list',
        name: 'billingGroupCoachingPreviewList',
        component: GroupCoachingPreviewList
    },
    {
        path: 'assisted-living-coaching-preview-list',
        name: 'billingAssistedLivingCoachingPreviewList',
        component: AssistedLivingCoachingPreviewList
    },
    {
        path: 'case-management-coaching-preview-list',
        name: 'billingCaseManagementCoachingPreviewList',
        component: CaseManagementCoachingPreviewList
    },
    {
        path: 'private-learning-coaching-preview-list',
        name: 'billingPrivateLearningCoachingPreviewList',
        component: PrivateLearningCoachingPreviewList
    },
    {
        path: 'socio-therapy-coaching-preview-list',
        name: 'billingSocioTherapyCoachingPreviewList',
        component: SocioTherapyCoachingPreviewList
    },
    {
        path: 'special-case-form',
        name: 'billingSpecialCaseForm',
        component: SpecialCaseForm
    },

    // Adjustment
    {
        path: 'socio-therapy-coaching-bill-correction/:id',
        name: 'billingSocioTherapyCoachingCorrection',
        component: SocioTherapyCoachingBillCorrectionForm
    },

];

export default routesBilling;